import {
    FETCH_PROCEDURE_LOOKUP_REQUEST,
    FETCH_PROCEDURE_LOOKUP_SUCCESS,
    FETCH_PROCEDURE_LOOKUP_FAILURE,
  } from "./FetchProcedureLookupTypes";
  import api from "../../utils/Api";
  
  export const fetchProcedureLookupRequest = () => {
    return {
      type: FETCH_PROCEDURE_LOOKUP_REQUEST,
    };
  };
  
  export const fetchProcedureLookupSuccess = (proceduresList) => {
    return {
      type: FETCH_PROCEDURE_LOOKUP_SUCCESS,
      payload: proceduresList,
    };
  };
  
  export const fetchProcedureLookupFailure = (error) => {
    return {
      type: FETCH_PROCEDURE_LOOKUP_FAILURE,
      payload: error,
    };
  };
  
  export const fetchProcedureLookup = (payload) => {
    const headers = {
      Authorization:
        "Bearer " + JSON.parse(localStorage.getItem("USER_INFO")).token,
    };
    let url = "medprax/tariffcode/lookup/fetch?appointment_id="+ payload.appointment_id +"&practitioner_id="+payload.practitioner_id+"&patient_id="+payload.patient_id +"&tariff_code="+payload.tariff_code+"&year="+payload.year

    return async (dispatch) => {
      dispatch(fetchProcedureLookupRequest);
      try {
        const response = await api.get(
          url,
          {
            headers: headers,
          }
        );
  
        const procedureLookup = response.data.data;
        dispatch(fetchProcedureLookupSuccess(procedureLookup));
      } catch (error) {
        console.log("Redux error - ", error.response);
        const errorMsg =  error.response.data && 
        error.response.data.message?error.response.data.message: error.message;
        dispatch(fetchProcedureLookupFailure(errorMsg));
      }
    };
  };
  